import { BaseEntity } from "./BaseEntity";

export enum NotificationStatus {
  UNREAD = 'unread',
  READ = 'read'
}

export enum NotificationType {
  MEETING_REMINDER = 'meeting_reminder',
  TASK_REMINDER = 'task_reminder',
  FAMILY_INACTIVE = 'family_inactive'
}

export enum RelatedEntityType {
  MEETING = 'meeting',
  TASK = 'task',
  FAMILY = 'family'
}
export interface Notification extends BaseEntity {
  user_id: string;
  type: NotificationType;
  content: string;
  date_time: Date;
  status: NotificationStatus;
  related_entity_id: string;
  related_entity_type: RelatedEntityType;
}
export type CreateNotificationDTO = Omit<Notification, '_id' | 'createdAt' | 'updatedAt'>;

